import { render, staticRenderFns } from "./huasuhui.vue?vue&type=template&id=78dbd5b4&scoped=true&"
import script from "./huasuhui.vue?vue&type=script&lang=js&"
export * from "./huasuhui.vue?vue&type=script&lang=js&"
import style0 from "./huasuhui.vue?vue&type=style&index=0&id=78dbd5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dbd5b4",
  null
  
)

export default component.exports